/* tslint:disable */
/* eslint-disable */

// @ts-ignore
import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// @ts-ignore
import type { ConfigurationParameters } from "../configuration";
// @ts-ignore
import { Configuration as OpenApiGeneratorConfiguration } from "../configuration";
// @ts-ignore
import type { AxiosError, AxiosResponse } from "axios";
import {
  useQuery,
  UseMutationOptions,
  useMutation,
  UseQueryOptions,
  // @ts-ignore
} from "react-query";
// @ts-ignore
import {
  useAuthorizationToken,
  useAuthQueryKey,
  useApiBasePath,
} from "../../utils";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { DemandStatus } from "../models";
// @ts-ignore
import { FiltersDto } from "../models";
// @ts-ignore
import { HistoryPageDto } from "../models";
// @ts-ignore
import { SlotRequestPageDto } from "../models";
/**
 * RequestWebServicesApi - axios parameter creator
 * @export
 */
export const RequestWebServicesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeRequest: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("completeRequest", "id", id);
      const localVarPath = `/request/complete/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [season]
     * @param {boolean} [com]
     * @param {boolean} [other]
     * @param {string} [airline]
     * @param {string} [partner]
     * @param {string} [slotId]
     * @param {number} [page]
     * @param {DemandStatus} [status]
     * @param {string} [pattern]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllSlotRequests: async (
      season?: string,
      com?: boolean,
      other?: boolean,
      airline?: string,
      partner?: string,
      slotId?: string,
      page?: number,
      status?: DemandStatus,
      pattern?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/requests`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (season !== undefined) {
        localVarQueryParameter["season"] = season;
      }

      if (com !== undefined) {
        localVarQueryParameter["com"] = com;
      }

      if (other !== undefined) {
        localVarQueryParameter["other"] = other;
      }

      if (airline !== undefined) {
        localVarQueryParameter["airline"] = airline;
      }

      if (partner !== undefined) {
        localVarQueryParameter["partner"] = partner;
      }

      if (slotId !== undefined) {
        localVarQueryParameter["slotId"] = slotId;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      if (pattern !== undefined) {
        localVarQueryParameter["pattern"] = pattern;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSlotFilters: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/filters`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSlotHistory: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("getSlotHistory", "id", id);
      const localVarPath = `/history`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undoRequest: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("undoRequest", "id", id);
      const localVarPath = `/request/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, configuration?.basePath);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestWebServicesApi - functional programming interface
 * @export
 */
export const RequestWebServicesApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    RequestWebServicesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async completeRequest(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.completeRequest(
        id,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} [season]
     * @param {boolean} [com]
     * @param {boolean} [other]
     * @param {string} [airline]
     * @param {string} [partner]
     * @param {string} [slotId]
     * @param {number} [page]
     * @param {DemandStatus} [status]
     * @param {string} [pattern]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllSlotRequests(
      season?: string,
      com?: boolean,
      other?: boolean,
      airline?: string,
      partner?: string,
      slotId?: string,
      page?: number,
      status?: DemandStatus,
      pattern?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SlotRequestPageDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAllSlotRequests(
          season,
          com,
          other,
          airline,
          partner,
          slotId,
          page,
          status,
          pattern,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSlotFilters(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiltersDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSlotFilters(
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSlotHistory(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoryPageDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSlotHistory(
        id,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async undoRequest(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.undoRequest(
        id,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        configuration?.basePath,
        configuration
      );
    },
  };
};

/**
 * RequestWebServicesApi - factory interface
 * @export
 */
export const RequestWebServicesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestWebServicesApiFp(configuration);
  return {
    /**
     *
     * @param {RequestWebServicesApiCompleteRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeRequest(
      requestParameters: RequestWebServicesApiCompleteRequestRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .completeRequest(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RequestWebServicesApiGetAllSlotRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllSlotRequests(
      requestParameters: RequestWebServicesApiGetAllSlotRequestsRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<SlotRequestPageDto> {
      return localVarFp
        .getAllSlotRequests(
          requestParameters.season,
          requestParameters.com,
          requestParameters.other,
          requestParameters.airline,
          requestParameters.partner,
          requestParameters.slotId,
          requestParameters.page,
          requestParameters.status,
          requestParameters.pattern,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSlotFilters(options?: AxiosRequestConfig): AxiosPromise<FiltersDto> {
      return localVarFp
        .getSlotFilters(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RequestWebServicesApiGetSlotHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSlotHistory(
      requestParameters: RequestWebServicesApiGetSlotHistoryRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<HistoryPageDto> {
      return localVarFp
        .getSlotHistory(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RequestWebServicesApiUndoRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undoRequest(
      requestParameters: RequestWebServicesApiUndoRequestRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .undoRequest(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for completeRequest operation in RequestWebServicesApi.
 * @export
 * @interface RequestWebServicesApiCompleteRequestRequest
 */
export interface RequestWebServicesApiCompleteRequestRequest {
  /**
   *
   * @type {string}
   * @memberof RequestWebServicesApiCompleteRequest
   */
  readonly id: string;
}

/**
 * Request parameters for getAllSlotRequests operation in RequestWebServicesApi.
 * @export
 * @interface RequestWebServicesApiGetAllSlotRequestsRequest
 */
export interface RequestWebServicesApiGetAllSlotRequestsRequest {
  /**
   *
   * @type {string}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly season?: string;

  /**
   *
   * @type {boolean}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly com?: boolean;

  /**
   *
   * @type {boolean}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly other?: boolean;

  /**
   *
   * @type {string}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly airline?: string;

  /**
   *
   * @type {string}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly partner?: string;

  /**
   *
   * @type {string}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly slotId?: string;

  /**
   *
   * @type {number}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly page?: number;

  /**
   *
   * @type {DemandStatus}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly status?: DemandStatus;

  /**
   *
   * @type {string}
   * @memberof RequestWebServicesApiGetAllSlotRequests
   */
  readonly pattern?: string;
}

/**
 * Request parameters for getSlotHistory operation in RequestWebServicesApi.
 * @export
 * @interface RequestWebServicesApiGetSlotHistoryRequest
 */
export interface RequestWebServicesApiGetSlotHistoryRequest {
  /**
   *
   * @type {string}
   * @memberof RequestWebServicesApiGetSlotHistory
   */
  readonly id: string;
}

/**
 * Request parameters for undoRequest operation in RequestWebServicesApi.
 * @export
 * @interface RequestWebServicesApiUndoRequestRequest
 */
export interface RequestWebServicesApiUndoRequestRequest {
  /**
   *
   * @type {string}
   * @memberof RequestWebServicesApiUndoRequest
   */
  readonly id: string;
}

/**
 * RequestWebServicesApi - object-oriented interface
 * @export
 * @class RequestWebServicesApi
 * @extends {BaseAPI}
 */
export class RequestWebServicesApi extends BaseAPI {
  /**
   *
   * @param {RequestWebServicesApiCompleteRequestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestWebServicesApi
   */
  public completeRequest(
    requestParameters: RequestWebServicesApiCompleteRequestRequest,
    options?: AxiosRequestConfig
  ) {
    return RequestWebServicesApiFp(this.configuration)
      .completeRequest(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RequestWebServicesApiGetAllSlotRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestWebServicesApi
   */
  public getAllSlotRequests(
    requestParameters: RequestWebServicesApiGetAllSlotRequestsRequest = {},
    options?: AxiosRequestConfig
  ) {
    return RequestWebServicesApiFp(this.configuration)
      .getAllSlotRequests(
        requestParameters.season,
        requestParameters.com,
        requestParameters.other,
        requestParameters.airline,
        requestParameters.partner,
        requestParameters.slotId,
        requestParameters.page,
        requestParameters.status,
        requestParameters.pattern,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestWebServicesApi
   */
  public getSlotFilters(options?: AxiosRequestConfig) {
    return RequestWebServicesApiFp(this.configuration)
      .getSlotFilters(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RequestWebServicesApiGetSlotHistoryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestWebServicesApi
   */
  public getSlotHistory(
    requestParameters: RequestWebServicesApiGetSlotHistoryRequest,
    options?: AxiosRequestConfig
  ) {
    return RequestWebServicesApiFp(this.configuration)
      .getSlotHistory(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RequestWebServicesApiUndoRequestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestWebServicesApi
   */
  public undoRequest(
    requestParameters: RequestWebServicesApiUndoRequestRequest,
    options?: AxiosRequestConfig
  ) {
    return RequestWebServicesApiFp(this.configuration)
      .undoRequest(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

// custom hook generation here
export type PostCompleteRequestResponse = AxiosResponse<void>;
export const KeyPostCompleteRequest = "PostCompleteRequest";
export const useMutationPostCompleteRequest = (
  options?: UseMutationOptions<
    PostCompleteRequestResponse,
    AxiosError,
    RequestWebServicesApiCompleteRequestRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    PostCompleteRequestResponse,
    AxiosError,
    RequestWebServicesApiCompleteRequestRequest
  >(
    (args: RequestWebServicesApiCompleteRequestRequest) =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).completeRequest(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryPostCompleteRequest = (
  args: RequestWebServicesApiCompleteRequestRequest,
  options?: UseQueryOptions<PostCompleteRequestResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<PostCompleteRequestResponse, AxiosError>(
    [KeyPostCompleteRequest, args, options && options.queryKey, authQueryKey],
    () =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).completeRequest(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type GetGetAllSlotRequestsResponse = AxiosResponse<SlotRequestPageDto>;
export const KeyGetGetAllSlotRequests = "GetGetAllSlotRequests";
export const useMutationGetGetAllSlotRequests = (
  options?: UseMutationOptions<
    GetGetAllSlotRequestsResponse,
    AxiosError,
    RequestWebServicesApiGetAllSlotRequestsRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    GetGetAllSlotRequestsResponse,
    AxiosError,
    RequestWebServicesApiGetAllSlotRequestsRequest
  >(
    (args: RequestWebServicesApiGetAllSlotRequestsRequest) =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).getAllSlotRequests(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetGetAllSlotRequests = (
  args: RequestWebServicesApiGetAllSlotRequestsRequest,
  options?: UseQueryOptions<GetGetAllSlotRequestsResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetGetAllSlotRequestsResponse, AxiosError>(
    [KeyGetGetAllSlotRequests, args, options && options.queryKey, authQueryKey],
    () =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).getAllSlotRequests(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type GetGetSlotFiltersResponse = AxiosResponse<FiltersDto>;
export const KeyGetGetSlotFilters = "GetGetSlotFilters";
export const useMutationGetGetSlotFilters = (
  options?: UseMutationOptions<GetGetSlotFiltersResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<GetGetSlotFiltersResponse, AxiosError>(
    () =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).getSlotFilters(axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetGetSlotFilters = (
  options?: UseQueryOptions<GetGetSlotFiltersResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetGetSlotFiltersResponse, AxiosError>(
    [KeyGetGetSlotFilters, options && options.queryKey, authQueryKey],
    () =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).getSlotFilters(axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type GetGetSlotHistoryResponse = AxiosResponse<HistoryPageDto>;
export const KeyGetGetSlotHistory = "GetGetSlotHistory";
export const useMutationGetGetSlotHistory = (
  options?: UseMutationOptions<
    GetGetSlotHistoryResponse,
    AxiosError,
    RequestWebServicesApiGetSlotHistoryRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    GetGetSlotHistoryResponse,
    AxiosError,
    RequestWebServicesApiGetSlotHistoryRequest
  >(
    (args: RequestWebServicesApiGetSlotHistoryRequest) =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).getSlotHistory(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryGetGetSlotHistory = (
  args: RequestWebServicesApiGetSlotHistoryRequest,
  options?: UseQueryOptions<GetGetSlotHistoryResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<GetGetSlotHistoryResponse, AxiosError>(
    [KeyGetGetSlotHistory, args, options && options.queryKey, authQueryKey],
    () =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).getSlotHistory(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export type DeleteUndoRequestResponse = AxiosResponse<void>;
export const KeyDeleteUndoRequest = "DeleteUndoRequest";
export const useMutationDeleteUndoRequest = (
  options?: UseMutationOptions<
    DeleteUndoRequestResponse,
    AxiosError,
    RequestWebServicesApiUndoRequestRequest
  >,
  axiosConfig?: AxiosRequestConfig
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();

  const res = useMutation<
    DeleteUndoRequestResponse,
    AxiosError,
    RequestWebServicesApiUndoRequestRequest
  >(
    (args: RequestWebServicesApiUndoRequestRequest) =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
        })
      ).undoRequest(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
export const useQueryDeleteUndoRequest = (
  args: RequestWebServicesApiUndoRequestRequest,
  options?: UseQueryOptions<DeleteUndoRequestResponse, AxiosError>,
  axiosConfig?: AxiosRequestConfig,
  conf?: ConfigurationParameters
) => {
  const basePath = useApiBasePath();
  const accessToken = useAuthorizationToken();
  const authQueryKey = useAuthQueryKey();

  const res = useQuery<DeleteUndoRequestResponse, AxiosError>(
    [KeyDeleteUndoRequest, args, options && options.queryKey, authQueryKey],
    () =>
      new RequestWebServicesApi(
        new OpenApiGeneratorConfiguration({
          accessToken,
          basePath,
          ...conf,
        })
      ).undoRequest(args, axiosConfig),
    options
  );
  return { ...res, data: res.data?.data };
};
